import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { i18n } from '@lib/i18n';
import { RegionEntity, LocationEntity } from '@modules/shared/entities';
import { schoolTypeTranslates } from '@modules/schools/constants';
import { SchoolRequisitesEntity } from './school-requisites-entity';

import type { School, SchoolType } from '@modules/types/graphql';

export type Entity = School | null;

@DecribeEntity('SchoolEntity')
class SchoolEntity extends BaseEntity {
    id: string;
    type: SchoolType | null;
    shortName: string;
    fullName: string;
    number: string;

    @Relation(() => LocationEntity)
    region: RegionEntity;

    @Relation(() => LocationEntity)
    location: LocationEntity;

    @Relation(() => SchoolRequisitesEntity)
    requisites: SchoolRequisitesEntity;

    constructor(school: Entity) {
        super(school);

        this.id = school?.id ?? '';
        this.type = school?.type ?? null;
        this.shortName = school?.shortName || '';
        this.fullName = school?.fullName || '';
        this.number = school?.number ? String(school.number) : '';
    }

    getHumanSchoolType() {
        if (this.type === null) {
            return '-';
        }

        const humanableType = i18n.t(schoolTypeTranslates[this.type]);

        return humanableType;
    }
}

export { SchoolEntity };
